/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useState } from "react";
import { useAppSelector } from "../../redux-tool-kit/Hooks";
import { MenuItem, SubMenuType } from "../../types/layout/SidebarType";
import Menulist from "./Menulist";
import { H6, LI } from "../../AbstractElements";
import { useTranslation } from "react-i18next";
import { useMenuList } from "../../data/layout-data/useMenuList";

const SidebarMenuList = () => {
  const [activeMenu, setActiveMenu] = useState<string[]>([]);
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const { t } = useTranslation();
  const menuList = useMenuList();

  const shouldHideMenu = (mainMenu: MenuItem) => {
    return mainMenu?.Items?.map((data: SubMenuType) => data.title).every(
      (titles) => pinedMenu.includes(titles || "")
    );
  };

  return (
    <>
      {menuList &&
        menuList.map((mainMenu: MenuItem, index: number) => (
          <Fragment key={index}>
            <LI
              className={`sidebar-main-title ${
                shouldHideMenu(mainMenu) ? "d-none" : ""
              }`}
            >
             
            </LI>
            <Menulist
              menu={mainMenu.Items}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              level={0}
            />
          </Fragment>
        ))}
    </>
  );
};

export default SidebarMenuList;